import { I } from "../ReportsPanel";

// Pantalla que se muestra al presionar "Nueva plantilla": elegir entre armar un reporte
// desde cero (flujo METRICS existente, sin cambios) o partir de una Plantilla SmartPay
// (reporte legacy pre-hecho).
export default function ChooserView({ onScratch, onSmartpay, onBack }) {
  return (
    <>
      <div className="rb-top-bar">
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <button className="rb-back-btn" onClick={onBack}><I.ArrowLeft /></button>
          <div className="rb-top-title">Nueva plantilla</div>
        </div>
      </div>
      <div className="rb-chooser-grid">
        <button className="rb-chooser-card" onClick={onScratch}>
          <div className="rb-chooser-card__icon"><I.Layout /></div>
          <div className="rb-chooser-card__title">Crear desde cero</div>
          <div className="rb-chooser-card__desc">Diseña un reporte usando métricas y bloques.</div>
        </button>
        <button className="rb-chooser-card" onClick={onSmartpay}>
          <div className="rb-chooser-card__icon"><I.Sparkle /></div>
          <div className="rb-chooser-card__title">Plantillas SmartPay</div>
          <div className="rb-chooser-card__desc">Utiliza uno de nuestros reportes preconfigurados.</div>
        </button>
      </div>
    </>
  );
}
